import stringify from 'postcss/lib/stringify';
import ApplicationController from './application_controller'

export default class extends ApplicationController {

  static targets = ['button', 'filterable']

  connect() {
    super.connect();
  }

  filter(event) {
    event.stopPropagation();

    const checked = event.target.checked;
    const filterable = this.filterableTarget;
    const filterBy = [];

    this.buttonTargets.forEach(button => {
      if (button.checked) {
        filterBy.push(button.dataset.validationstatus);
      }
    });
    console.log("filterBy ", filterBy.join(" - "));

    const ads = this.filterableTarget.querySelectorAll("li");
    console.log("ads: ", ads.length);

    // hide all ads first of all if filters are given
    // if no filters => show all ads
    for (let i = 0; i < ads.length; i++) {
      const element = ads[i];
      if (filterBy.length == 0) {
        element.classList.remove('hidden');
      } else {
        element.classList.add('hidden');
      }
    };


    for (let j = 0; j < filterBy.length; j++) {
      this.filterableTarget.querySelectorAll(`li.${filterBy[j]}`).forEach(ad => {
        ad.classList.remove('hidden');
      });
    };
  }
}
